import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { fetchProperties } from '../api';
import '../css/Navbar.css';

const Navbar = ({ darkMode, toggleTheme }) => {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [propertyCount, setPropertyCount] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Fetch property count for badge
  useEffect(() => {
    const loadCount = async () => {
      try {
        const data = await fetchProperties();
        if (data && Array.isArray(data)) {
          setPropertyCount(data.length);
        }
      } catch (e) {
        // silently fail — badge is optional
      }
    };
    loadCount();
  }, []);

  return (
    <nav className={`navbar navbar-expand-lg fixed-top transition-all ${isScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src="/images/logo.png" alt="Prathamesh Developers" height="40" className="me-2 whiteimg" />
          <span>Prathamesh Developers</span>
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto me-auto">
            {[
              { to: '/', label: 'Home' },
              { to: '/about', label: 'About Us' },
              { to: '/projects', label: 'Projects', badge: propertyCount },
              { to: '/contact', label: 'Contact' }
            ].map(({ to, label, badge }) => (
              <li className="nav-item" key={to}>
                <Link
                  className={`nav-link ${location.pathname === to ? 'active' : ''}`}
                  to={to}
                  onClick={() => {
                    const navEl = document.getElementById('navbarNav');
                    if (navEl && navEl.classList.contains('show')) {
                      const bsCollapse = window.bootstrap?.Collapse?.getInstance(navEl);
                      if (bsCollapse) {
                        bsCollapse.hide();
                      } else {
                        navEl.classList.remove('show');
                      }
                    }
                  }}
                >
                  {label}
                  {badge !== null && badge !== undefined && (
                    <span className="nav-count-badge ms-1">{badge}</span>
                  )}
                </Link>
              </li>
            ))}
          </ul>

          <div className="d-flex">
  <button
  onClick={toggleTheme}
  className="theme-toggle-btn btn-outline-primary"
  aria-label="Toggle theme"
>
  {darkMode ? (
    <i className="far fa-sun theme-icon sun" aria-hidden="true" />
  ) : (
    <i className="far fa-moon theme-icon moon" aria-hidden="true" />
  )}
</button>

</div>

        </div>
      </div>
    </nav>
  );
};

export default Navbar;
